// PDF React View
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { downloadPDFInvoices, previewPdfErrorInvoice } from "store/actions";
import "./style.scss";
import { LADHDDT_LABEL, LCTDT_LABEL, TCTBAO_LABEL } from "./utils";
const ListHDonModal = props => {
  const { isOpen, toggle, dataListHDon, isTaxDeduct } = props;
  const errorInvoices = useSelector(state => state.errorInvoices);
  const { fileDownload, fileDownloadName, type, previewPdfErrorFile } =
    errorInvoices;
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  useEffect(() => {
    if (isOpen) {
    } else {
    }
  }, [isOpen]);

  const tableInvoice = (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr className="text-info">
            <th scope="col">STT</th>
            <th scope="col">Số hóa đơn</th>
            <th scope="col" style={{ width: "200px" }}>
              Ký hiệu mẫu số hóa đơn
            </th>
            <th scope="col">Ký hiệu hóa đơn</th>
            <th scope="col">Lý do </th>
            <th scope="col">Loại áp dụng hóa đơn điện tử</th>
            <th scope="col">Tính chất thông báo </th>
            <th scope="col">Ngày lập hóa đơn </th>
          </tr>
        </thead>
        <tbody>
          {dataListHDon &&
            dataListHDon.cellContent &&
            dataListHDon.cellContent.map((item, key) => (
              <tr key={key}>
                <td>{key + 1}</td>
                <td>{item.SHDon}</td>
                <td>{item.KHMSHDon}</td>
                <td>{item.KHHDon}</td>
                <td>{item.LDo}</td>
                <td>{item.LADHDDT + " - " + LADHDDT_LABEL[item.LADHDDT]}</td>
                <td>{item.TCTBao + " - " + TCTBAO_LABEL[item.TCTBao]}</td>
                <td>{item.Ngay}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );

  const tableTaxDeduct = (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr className="text-info">
            <th scope="col">STT</th>
            <th scope="col">Số chứng từ</th>
            <th scope="col" style={{ width: "200px" }}>
              Ký hiệu mẫu số chứng từ
            </th>
            <th scope="col">Ký hiệu chứng từ</th>
            <th scope="col">Lý do </th>
            <th scope="col">Loại chứng từ điện tử</th>
            <th scope="col">Ngày lập chứng từ </th>
          </tr>
        </thead>
        <tbody>
          {dataListHDon &&
            dataListHDon.cellContent &&
            dataListHDon.cellContent.map((item, key) => (
              <tr key={key}>
                <td>{key + 1}</td>
                <td>{item.SCTu}</td>
                <td>{item.KHMSCTu}</td>
                <td>{item.KHCTu}</td>
                <td>{item.LDo}</td>
                <td>{item.LCTDT + " - " + LCTDT_LABEL[item.LCTDT]}</td>
                <td>{item.NLap}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>
            {isTaxDeduct
              ? "Danh sách chứng từ sai sót"
              : "Danh sách hóa đơn sai sót"}
          </Label>
        </ModalHeader>
        <ModalBody>{isTaxDeduct ? tableTaxDeduct : tableInvoice}</ModalBody>
        <ModalFooter>
          <Dropdown
            className="button-dropdown-pdf"
            direction="left"
            isOpen={dropdownOpen}
            disabled={previewPdfErrorFile.loading}
            toggle={toggleDropdown}
          >
            <DropdownToggle caret>
              {previewPdfErrorFile.loading && (
                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              )}
              Download PDF <i className="fas fa-chevron-up"></i>
            </DropdownToggle>
            <DropdownMenu className="download-dropdown">
              <DropdownItem
                onClick={() => {
                  dispatch(
                    previewPdfErrorInvoice(
                      dataListHDon && dataListHDon.row.id,
                      "review-pdf",
                      isTaxDeduct
                    )
                  );
                }}
              >
                Bản hiển thị thông báo
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  dispatch(
                    downloadPDFInvoices(
                      dataListHDon && dataListHDon.row?.id,
                      dataListHDon && dataListHDon.row?.ten,
                      isTaxDeduct
                        ? "approve-pdf-tax-deduct-error"
                        : "approve-pdf-error",
                      null
                    )
                  );
                }}
              >
                Kết quả CQT phản hồi
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </ModalFooter>
      </div>
    </Modal>
  );
};

ListHDonModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataListHDon: PropTypes.any,
  isTaxDeduct: PropTypes.bool,
};

export default ListHDonModal;
